import { useEffect, useState } from 'react';
import { fetchUserDealRestrictions } from '../services/admin-service';

/**
 * useUserDealRestrictions
 * Fetches and returns the current user's deal restrictions.
 * Returns { restrictions, loading, error }
 */
export default function useUserDealRestrictions() {
  const [restrictions, setRestrictions] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    setLoading(true);
    setError(null);
    fetchUserDealRestrictions()
      .then(res => {
        const results = (res && res.results) || [];
        setRestrictions(results);
        setLoading(false);
      })
      .catch(e => {
        setError(e);
        setLoading(false);
      });
  }, []);

  return { restrictions, loading, error };
}
